module.exports = __webpack_public_path__ + "public/Icons/20Changepassword.svg?0e34b2dd";